import CircularProgress from '@mui/material/CircularProgress';
import './WithLoader.scss';
import { FC, PropsWithChildren } from 'react';

export type WithLoaderProps = PropsWithChildren<{
  loading: boolean;
  size?: number;
}>;

const WithLoader: FC<WithLoaderProps> = ({ loading, children, size = 100 }) => {
  return (
    <div className="with-loader">
      {children}
      {loading && (
        <div className="with-loader__active">
          <CircularProgress size={size} disableShrink />
        </div>
      )}
    </div>
  );
};

export default WithLoader;
